<section class="section-compra" id="compra">

  <!-- ── Cabeçalho ── -->
  <div class="compra-header">
    <div class="compra-label anim">
      <!-- <h4>breakers</h4> -->
      <span class="compra-eyebrow">Compre Agora</span>
    </div>
    <h2 class="compra-title anim anim--delay-1">Adquira o Seu</h2>
    <div class="compra-divider anim anim--delay-2"></div>
    <p class="compra-subtitle anim anim--delay-3">
      Escolha o formato que combina com você.<br>
      Físico ou digital — a saga começa agora.
    </p>
  </div>

  <!-- ── Cards ── -->
  <div class="compra-cards">

    <!-- ═══ Digital ═══ -->
    <div class="compra-card anim anim--delay-1">

      <div class="card-cover-area">
        <img
          src="assets/images/kindle-capa-breakers.png"
          alt="Breakers – Edição Digital Kindle"
          class="card-cover"
          loading="lazy"
        />
      </div>

      <div class="card-body">
        <span class="card-format-chip">e-book</span>
        <h3 class="card-title">Edição Digital</h3>
        <p class="card-desc">
          Leia imediatamente em qualquer dispositivo com o app Kindle — sem espera, sem frete.
        </p>

        <div class="marketplace-links">
          <a
            href="https://www.amazon.com.br/dp/B09NZ58ZQN"
            target="_blank"
            rel="noopener noreferrer"
            class="marketplace-link"
            aria-label="Comprar no Kindle Unlimited"
          >
            <img src="assets/images/markplaces/kindle_unlimited.png" alt="Kindle Unlimited" class="mp-logo" />
            <span class="mp-name">Kindle Unlimited</span>
            <svg class="mp-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </a>
        </div>
      </div>

    </div>

    <!-- ═══ Físico — DESTAQUE ═══ -->
    <div class="compra-card compra-card--destaque anim anim--delay-2">

      <div class="card-recommended-badge">Mais Popular</div>

      <div class="card-cover-area card-cover-area--destaque">
        <div class="discount-badge">14% OFF</div>
        <img
          src="assets/images/livro-breakers.png"
          alt="Breakers – Edição Física com brindes"
          class="card-cover"
          loading="lazy"
        />
      </div>

      <div class="card-body">
        <span class="card-format-chip card-format-chip--destaque">impresso</span>
        <h3 class="card-title">Edição Física</h3>

        <div class="price-group">
          <span class="price-old">De R$ 69,90</span>
          <span class="price-new">
            <span class="price-currency">R$</span>59<span class="price-cents">,90</span>
          </span>
          <div class="badge-frete">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <rect x="1" y="3" width="15" height="13" rx="1"/>
              <path d="M16 8h4l3 5v3h-7V8z"/>
              <circle cx="5.5" cy="18.5" r="2.5"/>
              <circle cx="18.5" cy="18.5" r="2.5"/>
            </svg>
            Frete Grátis · Todo o Brasil
          </div>
        </div>

        <div class="marketplace-links">
          <a
            href="https://www.amazon.com.br/Breakers-Queda-das-Chamas-brindes/dp/6558991365/ref=tmm_pap_swatch_0?_encoding=UTF8&qid=&sr="
            target="_blank"
            rel="noopener noreferrer"
            class="marketplace-link"
            aria-label="Comprar na Amazon"
          >
            <img src="assets/images/markplaces/amazon.png" alt="Amazon" class="mp-logo" />
            <span class="mp-name">Amazon</span>
            <svg class="mp-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </a>
          <a
            href="https://produto.mercadolivre.com.br/MLB-2620820155-livro-breakers-a-queda-das-chamas-com-brindes-_JM#position=1&search_layout=stack&type=item&tracking_id=e4c19055-d7fd-4fe5-8714-41b81bd661c4"
            target="_blank"
            rel="noopener noreferrer"
            class="marketplace-link"
            aria-label="Comprar no Mercado Livre"
          >
            <img src="assets/images/markplaces/mercado-livre.png" alt="Mercado Livre" class="mp-logo" />
            <span class="mp-name">Mercado Livre</span>
            <svg class="mp-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </a>
        </div>
      </div>

    </div>

  </div>

</section>
